module.exports = __webpack_public_path__ + "static/img/15.789ca26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/15.png
// module id = fVbg
// module chunks = 0